import React from 'react';
import ReactNumberFormat from 'react-number-format';
import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';

function NumberFormatInput({
  customInput,
  isNumericString,
  onChange,
  prefix,
  suffix,
  thousandSeparator,
  ...props
}) {
  return (
    <ReactNumberFormat
      customInput={customInput}
      isNumericString={isNumericString}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
      prefix={prefix}
      suffix={suffix}
      thousandSeparator={thousandSeparator}
      {...props}
    />
  );
}

NumberFormatInput.propTypes = {
  customInput: PropTypes.elementType,
  isNumericString: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  prefix: PropTypes.string,
  suffix: PropTypes.string,
  thousandSeparator: PropTypes.bool,
};

NumberFormatInput.defaultProps = {
  customInput: TextField,
  isNumericString: false,
  prefix: '',
  suffix: '',
  thousandSeparator: false,
};

export default NumberFormatInput;
